export var DefaultContext = {
    color: undefined,
    size: '1em',
    className: undefined,
    style: undefined,
    attr: undefined,
};
export var IconContextKey = Symbol('VueIconContextKey');
//export const IconContext: React.Context<IconContext> = React.createContext && React.createContext(DefaultContext);
